import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    connect,
    Provider,
} from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConnectedRouter } from 'connected-react-router';

import { createHashHistory as createHistory } from 'history';

import initReactApp, { extractParams } from 'helpers/InitHelpers';
import { extractQueryParameters } from 'helpers/RoutesHelpers';
import {
    getLocationSelector,
} from '../commons/selectors/RouterSelector';

import configureStore from './Store';

import {
    initialState,
    reducerName,
    openModal,
    initCMPApp,
} from './reduxModules/ConsentManagementPlatform';

import GodBuster from '../components/GodBuster';

import CMPModal from './components/CMPModal';
import CMPBanner from './components/CMPBanner';

export const appSelector = '#js-app-cmp';

const propTypes = {
    AppActions: PropTypes.shape({
        openModal: PropTypes.func.isRequired,
        initCMPApp: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
};

const defaultProps = {
    location: {},
};

class CMP extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
    }

    componentDidMount() {
        const { AppActions } = this.props;
        AppActions.initCMPApp();
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal();
    }

    renderModalContent() {
        const { history, location } = this.props;
        const CMPModalLocation = {
            pathname: '',
            search: '',
            hash: '',
        };
        if (history && location) {
            CMPModalLocation.pathname = extractQueryParameters(location.search)['cmp-modal'] || '';
        }
        return (
            <ConnectedRouter history={history}>
                <CMPModal location={CMPModalLocation} />
            </ConnectedRouter>
        );
    }

    render() {
        return (
            <GodBuster>
                {this.renderModalContent()}
                <CMPBanner />
            </GodBuster>
        );
    }

}

CMP.propTypes = propTypes;

CMP.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        location: getLocationSelector(state),
    };
}

const ConnectedApp = connect(mapStateToProps, (dispatch) => ({
    AppActions: bindActionCreators({
        openModal,
        initCMPApp,
    }, dispatch),
}))(CMP);

export default ConnectedApp;

export function initCMPModalApp() {
    if (!document.querySelector(appSelector)) return;
    const params = extractParams(appSelector);
    const history = createHistory();
    const store = configureStore({
        [reducerName]: initialState,
    }, history);
    initReactApp(appSelector, (
        <Provider store={store}>
            <ConnectedApp
                history={history}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...params}
            />
        </Provider>
    ));
}

initCMPModalApp();
